import { Controller } from '@hotwired/stimulus';
import { postRequest, getRequest, isEmpty, kebabize } from '../src/utils';

// Connects to data-controller="turbo-modal"
export default class extends Controller {
  static targets = ['instrument'];
  static values = {
    school: Number,
    year: Number,
    instrument: String,
  };
  connect() {
    console.log('switch controller connectedd');
    console.log(this.schoolValue, this.yearValue, this.instrumentValue);
    this.checkAvailability();
  }
  async checkAvailability() {
    // Get spaces availability based on school and year group and then rended the band spaces turbo stream
    try {
      let resp = await this.fetchSpacesAvailability();
      let html = await resp.text();
      console.log(resp);
      await Turbo.renderStreamMessage(html);
      this.disableCurrentInstrument();
    } catch (error) {}
  }

  async fetchSpacesAvailability() {
    // Use school and band space to get band space information for each instrument
    try {
      return await getRequest(
        `/api/v1/band_spaces/get_availability?school_id=${this.schoolValue}&year_group=${this.yearValue}&switch_instruments=true`
      );
    } catch (error) {
      throw error;
    }
  }
}
